import { render } from "./network-form.vue?vue&type=template&id=22ab4b9f"
import script from "./network-form.vue?vue&type=script&lang=js"
export * from "./network-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__